import React from 'react';
import { TableCell, SxProps, Theme } from '@mui/material';
import { TmQ } from './TmInfoModal';
import { TS_COL_INFO, BI_COL_INFO } from './timeAndMaterialsColumnInfo';

const ALL_COL_HINTS: Record<string, string> = Object.fromEntries(
  [...Object.entries(TS_COL_INFO), ...Object.entries(BI_COL_INFO)].map(([k, v]) => [k, v.d]),
);

interface Props {
  label: string;
  infoKey: string;
  onInfo: (key: string) => void;
  align?: 'left' | 'right' | 'center';
  sx?: SxProps<Theme>;
  /** Override hover hint; defaults to Description from column dictionary */
  hint?: string;
}

/** Table column header — hover shows description; click label or ? opens info modal */
export const TmColHead: React.FC<Props> = ({
  label, infoKey, onInfo, align = 'left', sx, hint,
}) => {
  const hoverText = hint ?? ALL_COL_HINTS[infoKey] ?? label;
  return (
    <TableCell
      sx={sx}
      title={hoverText}
    >
      <span
        className="tm-col-head has-info"
        style={{ justifyContent: align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start' }}
        onClick={() => onInfo(infoKey)}
        role="button"
        tabIndex={0}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onInfo(infoKey); } }}
      >
        {label}
        <TmQ onClick={() => onInfo(infoKey)} />
      </span>
    </TableCell>
  );
};
